var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurtle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m374.99 81.022c-12.603 17.314-35.146 25.706-50.352 18.743-15.205-6.963-17.315-26.644-4.7115-43.958 12.603-17.314 35.146-25.706 50.352-18.743 15.205 6.963 17.315 26.644 4.7115 43.958z",
    fill: "#698000",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.66 45.109c0.55795 7.7396-2.1042 16.592-8.1562 24.906-12.597 17.305-35.178 25.709-50.375 18.75-4.0749-1.866-7.1818-4.657-9.3438-8.0625 0.59503 8.383 4.9383 15.442 12.844 19.062 15.198 6.9594 37.778-1.4446 50.375-18.75 9.2172-12.662 10.553-26.611 4.6562-35.906z",
    fillOpacity: 0.314
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.192 81.022c12.603 17.314 35.146 25.706 50.352 18.743 15.205-6.963 17.315-26.644 4.7115-43.958-12.603-17.314-35.146-25.706-50.352-18.743-15.205 6.963-17.315 26.644-4.7115 43.958z",
    fill: "#698000",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.005 56.952c-0.31268 7.5354 2.3551 16.05 8.1875 24.062 12.597 17.305 35.146 25.709 50.344 18.75 12.582-5.7615 16.183-20.239 9.9062-34.875-0.36264 8.7394-4.7454 16.138-12.906 19.875-15.198 6.9594-37.747-1.4446-50.344-18.75-2.1682-2.9787-3.8825-6.0194-5.1875-9.0625z",
    fillOpacity: 0.314
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m364.77 97.372c0 52.673-57.074 95.372-127.48 95.372-70.404 0-127.48-42.7-127.48-95.372 0-52.673 57.074-95.372 127.48-95.372 70.404 0 127.48 42.7 127.48 95.372z",
    fill: "#004000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.16 90.625c-0.20831 2.2293-0.34375 4.4811-0.34375 6.75 0 52.673 57.064 95.375 127.47 95.375 70.404 0 127.5-42.702 127.5-95.375 0-2.2689-0.13544-4.5207-0.34375-6.75-4.6275 49.524-59.785 88.625-127.16 88.625-67.372-1.5e-5 -122.5-39.102-127.12-88.625z",
    fill: "#808000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m354.38 59.64c1.8864 6.5232 2.9062 13.275 2.9062 20.219 0 52.646-57.132 95.375-127.5 95.375-52.451 1.5e-5 -97.504-23.734-117.06-57.625 12.422 42.929 63.482 75.125 124.56 75.125 70.368 0 127.5-42.729 127.5-95.375 0-13.405-3.7251-26.142-10.406-37.719z",
    fillOpacity: 0.314
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m336.22 147.63c20.5 15.5 95.5-28.5 131.5-14s-59.5 82.5-113.5 74.5-37-50.5-37-50.5c7.5543-16.997 19-10 19-10z",
    fill: "#698000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m298.68 164.73c0 33.186-50.191 65.156-60.119 65.156-10.557 0-60.119-31.97-60.119-65.156s26.933-60.119 60.119-60.119 60.119 26.933 60.119 60.119z",
    fill: "#698000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.8 157.48c0 9.7349-7.8917 17.627-17.627 17.627-9.7349 0-17.627-7.8917-17.627-17.627 0-9.7349 7.8917-17.627 17.627-17.627 9.7349 0 17.627 7.8917 17.627 17.627z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m230.88 149.12c0 3.1291-2.5366 5.6657-5.6657 5.6657s-5.6657-2.5366-5.6657-5.6657 2.5366-5.6657 5.6657-5.6657 5.6657 2.5366 5.6657 5.6657z"
  }), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.314
  }, /*#__PURE__*/React.createElement("path", {
    d: "m297.1 151.14c0.036621 0.86056 0.0625 1.7242 0.0625 2.5938 3.1e-5 33.186-50.165 65.156-60.094 65.156-9.4566 1.5e-5 -50.232-25.644-58.625-54.844-0.002594 0.22975 0 0.45714 0 0.6875 0 33.186 49.568 65.156 60.125 65.156 9.9287 0 60.094-31.97 60.094-65.156 0-4.6733-0.55203-9.2262-1.5625-13.594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.1 194.61c-2.658 15.535-12.482 28.288-25.594 34.031 2.1089 0.79547 3.85 1.25 5.0625 1.25 5.0513 0 20.518-8.2813 34.5-20.781-2.8072-5.8916-7.9668-10.899-13.969-14.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m473.69 137.76c-12.081 24.848-78.005 63.518-119.47 57.375-14.586-2.1609-23.978-6.8515-29.938-12.531-5.8609-14.242 0.48224-23.752 0.48224-23.752 5.2076-11.717 14.042-7.4327 17.924-6.4976v-1.9688c-2.5207-0.52348-4.7001-1.4127-6.4688-2.75 0 0-2.184-1.3541-5.2812-1.4375-0.24887-0.006699-0.49002-0.010986-0.75 0-3.8996 0.16466-8.985 2.4742-12.969 11.438 0 0-1.258 3.1769-2 7.9375-0.058563 0.37582-0.10504 0.76128-0.15625 1.1562-0.05835 0.44727-0.10968 0.87396-0.15625 1.3438-0.086853 0.87999-0.15512 1.8022-0.1875 2.75-0.015778 0.46191-0.031372 0.93082-0.03125 1.4062 1.53e-4 0.49516 0.011719 0.99206 0.03125 1.5 0.015717 0.40782 0.03302 0.80382 0.0625 1.2188 0.077026 1.107 0.21646 2.2302 0.40625 3.375 0.062531 0.37459 0.11136 0.7477 0.1875 1.125 0.044434 0.2213 0.10693 0.4342 0.15625 0.65625 0.082825 0.37085 0.1842 0.75258 0.28125 1.125 0.056854 0.21906 0.12552 0.43681 0.1875 0.65625 0.061218 0.21617 0.12118 0.43984 0.1875 0.65625 0.054321 0.17752 0.098419 0.35364 0.15625 0.53125 0.12674 0.38898 0.26205 0.76735 0.40625 1.1562 0.2309 0.62485 0.47138 1.2527 0.75 1.875 0.28482 0.63612 0.5993 1.2446 0.9375 1.875 0.32315 0.60232 0.68744 1.2182 1.0625 1.8125 0.036835 0.058228 0.056396 0.12936 0.09375 0.1875 0.29251 0.45636 0.61249 0.89371 0.9375 1.3438 0.1218 0.16834 0.24854 0.33267 0.375 0.5 0.40378 0.53519 0.82797 1.0702 1.2812 1.5938 0.50952 0.58846 1.0497 1.1478 1.625 1.7188 1.1439 1.1352 2.4195 2.2331 3.8438 3.2812 1.3828 1.0176 2.9216 1.9926 4.5938 2.9062 0.1141 0.062317 0.22824 0.12572 0.34375 0.1875 0.8006 0.42839 1.6302 0.84876 2.5 1.25 5.0906 2.3484 11.358 4.2243 19.125 5.375 49.936 7.398 135.36-50.198 119.47-70.375z",
    fillOpacity: 0.314
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.41 147.63c-20.5 15.5-95.5-28.5-131.5-14s59.5 82.5 113.5 74.5 37-50.5 37-50.5c-7.5543-16.997-19-10-19-10z",
    fill: "#698000",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.9403 137.76c12.081 24.848 78.005 63.518 119.47 57.375 28.013-4.1501 36.916-17.593 39-29.562 1.9819 12.696 0.26607 36.745-39 42.562-49.936 7.398-135.36-50.198-119.47-70.375z",
    fillOpacity: 0.314
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m221.22 86.627l65-2 14-31.5-41.5-28-44 32 6.5 29.5z",
    fillOpacity: 0.157
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.07 25.828c-14.943 9.8541-26.798 22.269-34.281 36.344l10.969 20 30.75-13.906-4.3125-42.281-3.125-0.1562z",
    fillOpacity: 0.196
  }), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.078
  }, /*#__PURE__*/React.createElement("path", {
    d: "m273.22 35.127l26.5 17.5 14-6.5-8-20-25-8-7.5 17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.22 83.625l-14.5 17 4.4062 19.031c1.4678 2.7132 3.0922 5.3552 4.875 7.9375l28.719 8.5312-1-27.5-22.5-25z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m278.7 157.48c0 9.7349-7.8917 17.627-17.627 17.627-9.7349 0-17.627-7.8917-17.627-17.627 0-9.7349 7.8917-17.627 17.627-17.627 9.7349 0 17.627 7.8917 17.627 17.627z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m275.88 149.12c0 3.1291-2.5366 5.6657-5.6657 5.6657s-5.6657-2.5366-5.6657-5.6657 2.5366-5.6657 5.6657-5.6657 5.6657 2.5366 5.6657 5.6657z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.078
  }, /*#__PURE__*/React.createElement("path", {
    d: "m318 127.89l28-7-11.5-37-24.5-1.5-16.5 20 24.5 25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220 86.39l-27 19-16-12.5 13-31.5 24.5-4.5 5.5 29.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m234 2.0312c-17.05 0.32318-33.246 3.1721-48 8.0312l-4 14.812 33.5 8 27-23-8.2188-7.8438c-0.093765 0.00162-0.18755-0.00178-0.28125 0z",
    fillOpacity: 0.118
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurtle);
export default __webpack_public_path__ + "static/media/turtle.c3444f0643793cb2ddbc218842d0227d.svg";
export { ForwardRef as ReactComponent };